import React, { Component }  from 'react'
import { connect } from 'react-redux'
import { Column, Table, AutoSizer  } from 'react-virtualized'
import 'react-virtualized/styles.css'
import * as R from 'ramda'
import { propertiesEx } from 'selectors/properties'
import tableActions from 'actions/table'
import routeActions from 'actions/routeActions'
import {currentSort, prop, selectedRows, route} from 'selectors/common'
import {properties} from 'selectors/entities'

let select = (state, props) => ({
	sort: currentSort(props.entity)(state)
  , selectedRows: selectedRows(props.entity, state)
  , route: route(state)
})

export class CommonTable extends Component {
    render(){
		let { props } = this
		let sort = props.sort
		let data = props.data
		let selectedRows = props.route[1] || props.selectedRows
		let rowHeight = 48
		let heightList = rowHeight * (data.length+1)
		return(
            <div
                className="data-table"
                style={{
                    width: "calc(100% - 55px)"
                  , height: props.showAll?heightList:"calc(100vh - 61px)"
                }}
            >
                <AutoSizer>
                    {({ width, height }) => (
                        <Table
                            width={width}
                            height={props.showAll?heightList:height}
                            headerHeight={48}
                            rowHeight={rowHeight}
                            rowCount={data.length}
                            rowClassName={(x)=>{
                                if (x.index==-1) return "tableHeaderClass"
                                else {
									if (data[x.index] && selectedRows && selectedRows == data[x.index]._id) return "tableRowClassSelected"
									else return "tableRowClass"
								}
                            }}
                            sortBy={sort.sortBy}
                            sortDirection={props.sort.sortDirection}
                            sort={(x)=>{props.SORT_CHANGE({entity: props.entity, ...x})}}
                            onRowClick = {({ rowData }) => {
								if (!rowData.link) {
									props.CHOOSE_ITEM({id:rowData._id, type: props.entity})
								} else {
									props.NAVIGATE(rowData.link)
								}
								}}
                            rowGetter={({ index }) => data[index]}
                        >
							{R.filter(x=>x)(props.children)}
                        </Table>
                    )}
                </AutoSizer>
            </div>
        )
    }
}

export default connect(select, {...tableActions, ...routeActions})(CommonTable)



// WEBPACK FOOTER //
// ./src/components/Table.js